import React, { useContext } from "react";
import { DeviceSection } from "../../context/DeviceContext";
import { useTranslation } from "react-i18next";
import { FiPlus, FiCpu, FiArrowRight } from "react-icons/fi";

const DeviceFirstPage = () => {
  const { ShowHideDeviceFunction } = useContext(DeviceSection);
  const { t } = useTranslation();

  return (
    <div className="device-first-page">
      <div className="device-first-card">
        <div className="device-first-icon">
          <FiCpu size={28} />
        </div>
        <div className="device-first-content">
          <h3 className="device-first-title">{t("اضافه کردن دستگاه")}</h3>
          <p className="device-first-description">
            {t("شما میتوانید دستگاه دلخواه خود را اضافه کنید")}
          </p>
        </div>
        <button
          className="device-first-btn"
          onClick={() => ShowHideDeviceFunction("scanDevice")}
        >
          <FiPlus size={22} />
        </button>
      </div>
    </div>
  );
};

export { DeviceFirstPage };